import React from 'react';
import PropTypes from 'prop-types';

import Button from './Button';

const getDimensions = (size) => {
  switch (size.toLowerCase()) {
  case 'xs':
    return 24;

  case 'sm':
    return 28;

  case 'md':
  default:
    return 40;
  }
};

const IconButton = ({
  size,
  icon,
  iconColor,
  iconProps,
  ...props
}) => {
  const dimensions = getDimensions(size);

  return (
    <Button
      display='flex'
      alignItems='center'
      justifyContent='center'
      width={dimensions}
      height={dimensions}
      p={0}
      leftIcon={{
        icon,
        mr: 0,
        ...iconProps,
      }}
      {...props}
    />
  );
};

IconButton.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  iconProps: PropTypes.object,
  size: PropTypes.string,
  iconColor: PropTypes.string,
};

IconButton.defaultProps = {
  icon: 'ellipsis-v',
  iconProps: {},
  size: 'md',
  iconColor: 'white',
};

export default IconButton;
